// Wind am Fluggerät aus der DJI-Telemetrie (dji_live.daten.wind_ms / wind_richtung, von dji-sync aus OSD wind_speed / wind_direction).
// Identische Kopie in apps/fuehrung/src/utils/drohnenWind.ts.

/**
 * Umrechnung des dji-sync-Rohwerts `wind_ms` in m/s – die EINZIGE Stelle dafür.
 * Annahme laut DJI-Doku: OSD wind_speed ist in 0,1 m/s (Faktor 0,1). AM ECHTEN GERÄT PRÜFEN: Liefert die Drohne
 * z. B. bei spürbar 5 m/s Wind den Wert 50, stimmt der Faktor; liegt der Wert direkt in m/s, Faktor auf 1 setzen.
 */
export const DROHNEN_WIND_FAKTOR = 0.1

/** Windrichtung (OSD wind_direction) ist ein Enum 1–8 */
const RICHTUNGEN_8 = ['N', 'NO', 'O', 'SO', 'S', 'SW', 'W', 'NW']

export interface DrohnenWind {
  /** m/s */
  ms: number
  /** km/h */
  kmh: number
  /** Himmelsrichtung, aus der der Wind kommt bzw. in die er weht laut DJI-Enum (nicht weiter interpretiert); null = unbekannt */
  richtung: string | null
}

/** Liefert null, wenn die Telemetrie keinen Windwert enthält */
export function drohnenWind(daten: Record<string, any> | null | undefined): DrohnenWind | null {
  const roh = daten?.wind_ms
  if (roh == null || !Number.isFinite(Number(roh))) return null
  const ms = Number(roh) * DROHNEN_WIND_FAKTOR
  const r = Number(daten?.wind_richtung)
  return { ms, kmh: ms * 3.6, richtung: Number.isInteger(r) && r >= 1 && r <= 8 ? RICHTUNGEN_8[r - 1] : null }
}
